import React, { useEffect } from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { createStructuredSelector } from 'reselect';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

import Grid from '../../../components/molecules/Grid';
import SearchBar from '../SearchBar';
import { getFilterdInfoData, clearFilterData } from '../Filters/redux/actions';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import { filteredData, selectedFiltersData } from '../Filters/redux/selectors';
import { searchTermData } from './redux/selectors';
import FilteredList from '../FilteredList';
import {
  LISTINGLAYOUT_COMPONENT,
  FILTER_SECTION,
  FILTEREEDLIST_SECTION,
} from './locators';
import useStyles from './style';
import { isFilterObjectEmpty } from '../../../../utils/utility';
import { getComponentName } from '../../../utils/getPageComponentInfo';

const payloadForSearchCall = (searchTerm, language) => {
  let solrPayloadToFetchFilter = {};
  solrPayloadToFetchFilter.searchTerm = searchTerm;
  solrPayloadToFetchFilter.language = language;
  solrPayloadToFetchFilter.facetFields = [];
  solrPayloadToFetchFilter.limit = 9;
  solrPayloadToFetchFilter.offset = 0;
  solrPayloadToFetchFilter.filters = [];

  return solrPayloadToFetchFilter;
};

const GlobalSearchSubLayout = props => {
  const { filteredData, searchTermData, sitecoreContext, appConfig = {} } = props;
  const classes = useStyles();
  const [stateSearchTerm, setStateSearchTerm] = React.useState('');
  const [isFirstLoad, setIsFirstLoad] = React.useState(true);
  let isSearchDataAvailable = Boolean(
    filteredData &&
    filteredData.data &&
    filteredData.data.results &&
    filteredData.data.results.length > 0
  );
  const searchPlaceholderText = get(
    props,
    'sitecoreContext.route.fields.searchPlaceholderText',
    ''
  );
  const filtersData = get(props, 'selectedFiltersData.data', '');
  const isFiltersApplied = !isFilterObjectEmpty(filtersData);
  const isLoading = get(filteredData, 'loading', '');
  const language = get(sitecoreContext, 'language', '');
  if (stateSearchTerm !== searchTermData.data) {
    const payload = payloadForSearchCall(searchTermData.data, language);
    props.getFilterdInfoData({
      apiUrl: `${appConfig.SOLR_SEARCH_API}`,
      payload: payload,
    });
    setStateSearchTerm(searchTermData.data);
  } else {
    if (isFiltersApplied) {
      isSearchDataAvailable = true;
    }
  }

  // Fetching Filtered Results
  useEffect(() => {
    if (isFirstLoad) {
      setIsFirstLoad(false);
    }
  }, []);

  return (
    <Grid item>
      <SearchBar
        placeHolder={searchPlaceholderText}
        isGlobalSearchPage={true}
        id={'search_bar_result_page'}
        appConfig={props.appConfig}
      />
      {!isSearchDataAvailable && !isLoading && !isFirstLoad && (
        <Placeholder name="no-search-result" rendering={props.rendering} appConfig={props.appConfig} />
      )}
      {isSearchDataAvailable && (
        <Grid
          item
          className={classes.listingLayoutWrappeer}
          data-locator={LISTINGLAYOUT_COMPONENT}
        >
          <Grid
            item
            className={classes.filterSection}
            data-locator={FILTER_SECTION}
          >
            <Placeholder name="vad-left-col" rendering={props.rendering} appConfig={props.appConfig} />
          </Grid>
          <Grid
            item
            className={classes.filterdList}
            data-locator={FILTEREEDLIST_SECTION}
            aria-live="polite"
          >
            <FilteredList searchTerm={searchTermData.data} componentName={getComponentName(props)} appConfig={props.appConfig} />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export const mapDispatchToProps = dispatch => {
  return {
    getFilterdInfoData: params => dispatch(getFilterdInfoData(params)),
    clearFilterData: params => dispatch(clearFilterData(params)),
  };
};

export const mapStateToProps = createStructuredSelector({
  filteredData: filteredData,
  searchTermData: searchTermData,
  selectedFiltersData: selectedFiltersData,
});

export default withErrorBoundary(
  withSitecoreContext()(
    withNamespaces()(
      connect(mapStateToProps, mapDispatchToProps)(GlobalSearchSubLayout)
    )
  )
);
